export default __webpack_public_path__ + "static/media/banner.d008d7f4.jpg";